module.exports = __webpack_public_path__ + "img/platinum-logo-450x225.27c83111.png";